import React from 'react'

function IndexPage() {
  return (
    <div>
      <h1>/Root</h1>
    </div>
  )
}

export default IndexPage
